export const STATUS_META = {
  open: { label: "Open", badge: "bg-gray-100 text-gray-800 border-gray-300", next: "ordered", nextLabel: "Mark Ordered" },
  ordered: { label: "Ordered from supplier", badge: "bg-blue-100 text-blue-800 border-blue-300", next: "arrived", nextLabel: "Mark Arrived" },
  arrived: { label: "Arrived (customer notified)", badge: "bg-amber-100 text-amber-800 border-amber-300", next: "collected", nextLabel: "Mark Collected" },
  collected: { label: "Collected / Closed", badge: "bg-green-100 text-green-800 border-green-300", next: null },
};

export const STATUS_ORDER = ["open", "ordered", "arrived", "collected"];

export const fmtR = (v) => `R ${(parseFloat(v) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

export const fmtDate = (d) => {
  if (!d) return "";
  const dt = new Date(d.length === 10 ? `${d}T00:00:00` : d);
  return dt.toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return `${dt.toLocaleDateString("en-ZA", { day: "2-digit", month: "short", timeZone: "Africa/Johannesburg" })} ${dt.toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Africa/Johannesburg" })}`;
};
